import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="w-full" style={{ backgroundColor: "oklch(var(--secondary-100))" }}>
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
            <div className="col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-4 no-underline cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-dribbble-line text-2xl" style={{ color: "oklch(var(--accent-500))" }}></i>
                </div>
                <span className="text-xl font-semibold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                  黄油网站
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
                {t("footer.brand_desc")}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">{t("footer.products")}</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/muban-sucai" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.templates")}</Link>
                <Link to="/category/sucaiku" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.assets")}</Link>
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.editor")}</a>
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.brand_kit")}</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">{t("footer.support")}</h4>
              <div className="flex flex-col gap-2.5">
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.help_center")}</a>
                <Link to="/category/shiyong-jiaocheng" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.tutorial")}</Link>
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.faq")}</a>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.contact")}</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">{t("footer.company")}</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.about_us")}</Link>
                <Link to="/category/sheji-linggan" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.blog")}</Link>
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.join_us")}</a>
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors no-underline cursor-pointer">{t("footer.partners")}</a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">{t("footer.copyright")}</p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 no-underline cursor-pointer">{t("footer.icp")}</a>
              <div className="flex items-center gap-3">
                <a href="#" className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-background-300/60 transition-colors cursor-pointer" aria-label="WeChat">
                  <i className="ri-wechat-line text-sm text-foreground-600"></i>
                </a>
                <a href="#" className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-background-300/60 transition-colors cursor-pointer" aria-label="Weibo">
                  <i className="ri-weibo-line text-sm text-foreground-600"></i>
                </a>
                <a href="#" className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-background-300/60 transition-colors cursor-pointer" aria-label="Xiaohongshu">
                  <i className="ri-china-railway-line text-sm text-foreground-600"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}